const messages = {
  en: {
    guides: 'Troubleshooting Guides'
  },
  'es-ud': {
    guides: 'Guías de Solución de Problemas'
  },
  es: {
    guides: 'Guías de Solución de Problemas'
  }
}

export default messages



// WEBPACK FOOTER //
// ./src/components/Guides/messages.js